import { s } from '@w/schema'

// ============================================================================
// Schemas for validation
// ============================================================================

export const ClientFileMetaSchema = s.object({
  uploadedAt: s.number().optional(),
  synced: s.boolean(),
  deletedAt: s.number().nullable(),
  size: s.number(),
})

export const ServerFileMetaSchema = s.object({
  uploadedAt: s.number(),
  deletedAt: s.number().nullable(),
  size: s.number(),
})

// ============================================================================
// Client metadata DB migrations
// ============================================================================

export const CLIENT_METADATA_MIGRATIONS = [
  // v1: Initial schema
  `CREATE TABLE IF NOT EXISTS files (
    path TEXT PRIMARY KEY,
    synced INTEGER NOT NULL,
    deletedAt INTEGER,
    size INTEGER NOT NULL
  );

  CREATE INDEX IF NOT EXISTS idx_files_synced ON files(synced);`,
  `CREATE TABLE IF NOT EXISTS scoped_pull_state (
    scope TEXT PRIMARY KEY,
    epoch TEXT NOT NULL,
    after INTEGER NOT NULL CHECK(after >= 0),
    until INTEGER NOT NULL CHECK(until >= after)
  );`,
  'ALTER TABLE files ADD COLUMN uploadedAt INTEGER;',
]

export const CLIENT_SQL = {
  // File meta
  getFileMeta: 'SELECT synced, deletedAt, size, uploadedAt FROM files WHERE path = ?',
  setFileMeta:
    'INSERT OR REPLACE INTO files (path, synced, deletedAt, size, uploadedAt) VALUES (?, ?, ?, ?, ?)',
  deleteFileMeta: 'DELETE FROM files WHERE path = ?',

  // Queries
  getUnsyncedFiles: 'SELECT path FROM files WHERE synced = 0',
  getAllFilePaths: 'SELECT path FROM files',

  getScopedPullState: 'SELECT scope, epoch, after, until FROM scoped_pull_state WHERE scope = ?',
  setScopedPullState: 'INSERT OR REPLACE INTO scoped_pull_state(scope, epoch, after, until) VALUES (?, ?, ?, ?)',
  clearScopedPullState: 'DELETE FROM scoped_pull_state WHERE scope = ?',

  // Utilities
  clear: 'DELETE FROM files; DELETE FROM scoped_pull_state',
}

// ============================================================================
// Server metadata DB migrations
// ============================================================================

export const SERVER_METADATA_MIGRATIONS = [
  // v1: Initial schema
  `CREATE TABLE IF NOT EXISTS files (
    path TEXT PRIMARY KEY,
    uploadedAt INTEGER NOT NULL,
    deletedAt INTEGER,
    size INTEGER NOT NULL
  );

  CREATE INDEX IF NOT EXISTS idx_files_uploadedAt ON files(uploadedAt) WHERE deletedAt IS NULL;

  CREATE INDEX IF NOT EXISTS idx_files_deletedAt ON files(deletedAt) WHERE deletedAt IS NOT NULL;`,
]

// Applied by the schema integrator after legacy rows have bounded backfill.
export const SERVER_SEQUENCE_MIGRATION = `
  ALTER TABLE files ADD COLUMN scope TEXT NOT NULL DEFAULT '';
  ALTER TABLE files ADD COLUMN resourceKey BLOB;
  ALTER TABLE files ADD COLUMN changeSeq INTEGER NOT NULL DEFAULT 0;
  CREATE TABLE metadata_sequence (id INTEGER PRIMARY KEY CHECK(id=1), value INTEGER NOT NULL, epoch INTEGER NOT NULL);
  INSERT INTO metadata_sequence VALUES (1,0,0);
  CREATE INDEX idx_files_scope_sequence ON files(scope,changeSeq);
  CREATE INDEX idx_files_pending_sequence ON files(changeSeq) WHERE changeSeq=0;
`

export const SERVER_SQL = {
  // File meta
  getFileMeta: 'SELECT uploadedAt, deletedAt, size FROM files WHERE path = ?',
  advanceSequence: 'UPDATE metadata_sequence SET value=value+1 WHERE id=1',
  advanceEpoch: 'UPDATE metadata_sequence SET epoch=epoch+1 WHERE id=1',
  listingHead: 'SELECT value AS until, epoch FROM metadata_sequence WHERE id=1',
  listingEpoch: 'SELECT epoch FROM metadata_sequence WHERE id=1',
  getFilesPage: `SELECT changeSeq,uploadedAt,deletedAt,size,resourceKey,
    length(CAST(path AS BLOB)) AS pathBytes, substr(CAST(path AS BLOB),1,65536) AS pathPart
    FROM files WHERE scope=? AND changeSeq>? AND changeSeq<=? ORDER BY changeSeq LIMIT 8`,
  getFilePathPart: `SELECT substr(CAST(path AS BLOB),?+1,65536) AS pathPart
    FROM files WHERE scope=? AND changeSeq=?`,
  setFileMeta: `INSERT INTO files(path,uploadedAt,deletedAt,size,scope,resourceKey,changeSeq)
    SELECT ?,?,?,?,?,?,value FROM metadata_sequence WHERE id=1
    ON CONFLICT(path) DO UPDATE SET uploadedAt=excluded.uploadedAt,
    deletedAt=excluded.deletedAt,size=excluded.size,scope=excluded.scope,resourceKey=excluded.resourceKey,changeSeq=excluded.changeSeq`,
  deleteFileMeta: 'DELETE FROM files WHERE path = ?',

  // Queries
  getDeletedFilesBefore: `
    SELECT path
    FROM files
    WHERE deletedAt IS NOT NULL AND deletedAt < ?
  `,

  // Utilities
  clear: 'DELETE FROM files',
}
